<template>
	<div v-if="activities" class="py-8">
		<Timeline :value="allActivities" class="-ml-[100%]">
			<template #content="slotProps">
				<HistoryTimelineCard :item="slotProps.item" :index="slotProps.index"/>
			</template>
		</Timeline>
	</div>
</template>

<script>
import FirmwarePropertiesForm from "@/Forms/Firmware/FirmwarePropertiesForm.vue";
import { mapStores } from "pinia";
import { useFirmwaresStore } from "@/stores/firmwares.js";
import HistoryTimelineCard from "@/Components/HistoryTimelineCard.vue";

export default {
	name: "FirmwareHistoryView",
	components: {HistoryTimelineCard, FirmwarePropertiesForm},
	data() {
		return {
			activities: undefined,
			releaseNoteActivities: undefined,
			testingDocumentActivities: undefined,
		}
	},
	computed: {
		...mapStores(useFirmwaresStore),
		allActivities() {
			return [
				...this.activities,
				...this.releaseNoteActivities.map(a => ({...a, description: this.$t('pages.admin.firmware.firmware.firmware.history.firmware_history_view.release_note_x', { description: a.description})})),
				...this.testingDocumentActivities.map(a => ({...a, description: this.$t('pages.admin.firmware.firmware.firmware.history.firmware_history_view.release_note_x', { description: a.description})})),
			].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
		},
	},
	methods: {
		async refreshFirmware() {
			return this.firmwaresStore.showFirmware(this.$route.params.firmware, {
				fields: {firmwares: 'id'},
				include: [
					'activities.causer',
					'releaseNotes.activities.causer',
					'testingDocuments.activities.causer'
				],
			});
		},
	},
	watch: {
		'$route.params.firmware': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.firmware === 'NEW') {
						this.activities = [];
					} else {
						const response = (await this.refreshFirmware());
						this.activities = response.activities;
						this.releaseNoteActivities = response.release_notes?.map(rn => rn.activities).flat();
						this.testingDocumentActivities = response.testing_documents?.map(td => td.activities).flat();
					}
				} else {
					this.activities = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>